type BidGuidanceValues = {
  high: string;
  low: string;
  recommended: string;
};

export const getBidGuidanceValues = (bidGuidanceLow?: number, bidGuidanceHigh?: number): BidGuidanceValues => {
  if (
    bidGuidanceLow === undefined ||
    bidGuidanceHigh === undefined ||
    bidGuidanceLow > bidGuidanceHigh ||
    bidGuidanceHigh === 0
  ) {
    return {
      high: 'N/A',
      low: 'N/A',
      recommended: 'N/A',
    };
  }

  const ceilToTwoDecimals = (value: number) => Math.ceil(value * 100) / 100;

  const recommendedLow = ceilToTwoDecimals(bidGuidanceLow);
  const recommendedHigh = ceilToTwoDecimals(bidGuidanceHigh);
  const highLowDifference = Math.round((recommendedHigh - recommendedLow + Number.EPSILON) * 100) / 100;
  const recommendedHighAdjusted = highLowDifference < 0.01 ? recommendedHigh + 0.01 : recommendedHigh;
  const recommended = `$${recommendedLow.toFixed(2)} - $${recommendedHighAdjusted.toFixed(2)}`;
  const high = `> $${(recommendedHighAdjusted + 0.01).toFixed(2)}`;
  const lowAdjusted = recommendedLow - 0.01;
  const low = lowAdjusted <= 0 ? 'N/A' : `< $${lowAdjusted.toFixed(2)}`;

  return {
    high,
    low,
    recommended,
  };
};
